import type { SwiperOptions } from 'swiper'
import { Navigation, Autoplay, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css/pagination'

import './styles.scss'

interface CarouselProps {
  children: React.ReactNode[]
}

interface Breakpoint {
  [width: number]: SwiperOptions
  [ratio: string]: SwiperOptions
}

interface TAutoplay {
  delay?: number
  disableOnInteraction?: boolean
  pauseOnMouseEnter?: boolean
}

interface CarouselOptions {
  slidesPerView?: number
  breakpoints?: Breakpoint
  className?: string
  autoplay?: TAutoplay
}

interface CarouselProps {
  children: React.ReactNode[]
  options?: CarouselOptions
}

export function Carousel({ children, options }: CarouselProps) {
  const optionsDefault: CarouselOptions = {
    autoplay: {
      delay: 60000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    slidesPerView: 1,
    className: 'swiper-carousel',
    ...options,
  }

  return (
    <Swiper
      pagination={{ clickable: true }}
      navigation={{
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      }}
      {...optionsDefault}
      modules={[Navigation, Autoplay, Pagination]}
    >
      <div className="swiper-button-prev" />
      <div className="swiper-button-next " />

      {children.map((item, index) => {
        return <SwiperSlide key={index}>{item}</SwiperSlide>
      })}
    </Swiper>
  )
}
